(function () {
  'use strict';


  /* =========================================================
     MOBILE ONLY
     ========================================================= */

  const MOBILE_BREAKPOINT = 768;


  if (
    window.innerWidth >=
    MOBILE_BREAKPOINT
  ) {
    return;
  }


  /* =========================================================
     STATE
     ========================================================= */

  let initialized = false;

  let stickyWrapper = null;

  let originalButton = null;

  let originalButtonObserver = null;

  let stickyLockedByDrawer = false;

  let drawerWatcher = null;

  let passedOriginalButton = false;


  /* =========================================================
     ORIGINAL FILTER BUTTON
     ========================================================= */

  function getOriginalFilterButton() {

    const buttons =
      document.querySelectorAll(
        '.products-toolbar__filter-btn.js-toggle-filters'
      );


    for (const button of buttons) {

      if (
        !button.closest(
          '.g3-mobile-sticky-filter'
        )
      ) {

        return button;

      }

    }


    return null;
  }


  /* =========================================================
     DRAWER
     ========================================================= */

  function getFilterDrawer() {

    const button =
      getOriginalFilterButton();


    if (!button) {

      return document.getElementById(
        'facet-filters'
      );

    }


    const drawerId =
      button.getAttribute(
        'aria-controls'
      );


    if (drawerId) {

      return document.getElementById(
        drawerId
      );

    }


    return document.getElementById(
      'facet-filters'
    );
  }


  function isFilterDrawerVisible() {

    const drawer =
      getFilterDrawer();


    if (!drawer) {
      return false;
    }


    if (drawer.hidden) {
      return false;
    }


    if (
      drawer.getAttribute(
        'aria-hidden'
      ) === 'true'
    ) {
      return false;
    }


    const styles =
      window.getComputedStyle(
        drawer
      );


    if (
      styles.display === 'none' ||
      styles.visibility === 'hidden'
    ) {
      return false;
    }


    if (
      parseFloat(styles.opacity) === 0 &&
      styles.pointerEvents === 'none'
    ) {
      return false;
    }


    const rect =
      drawer.getBoundingClientRect();


    return (
      rect.width > 0 &&
      rect.height > 0 &&
      rect.right > 0 &&
      rect.left < window.innerWidth &&
      rect.bottom > 0 &&
      rect.top < window.innerHeight
    );
  }


  /* =========================================================
     VISIBILITY
     ========================================================= */

  function updateStickyVisibility() {

    if (!stickyWrapper) {
      return;
    }


    const drawerVisible =
      isFilterDrawerVisible();


    const shouldShow =
      passedOriginalButton &&
      !drawerVisible &&
      !stickyLockedByDrawer;


    stickyWrapper.classList.toggle(
      'is-visible',
      shouldShow
    );
  }


  /* =========================================================
     WATCH ORIGINAL BUTTON
     ========================================================= */

  function observeOriginalButton() {

    const latestButton =
      getOriginalFilterButton();


    /*
     * Collection may not have filters.
     */
    if (!latestButton) {

      if (stickyWrapper) {

        stickyWrapper.classList.remove(
          'is-visible'
        );

      }

      return;
    }


    /*
     * Same button is already observed.
     */
    if (
      latestButton ===
      originalButton
    ) {
      return;
    }


    originalButton =
      latestButton;


    if (originalButtonObserver) {

      originalButtonObserver.disconnect();

    }


    originalButtonObserver =
      new IntersectionObserver(
        function (entries) {

          const entry =
            entries[0];


          if (!entry) {
            return;
          }


          /*
           * Sticky appears ONLY when original
           * button has passed ABOVE viewport.
           *
           * It does not appear merely because
           * button is below the viewport.
           */
          passedOriginalButton =
            !entry.isIntersecting &&
            entry.boundingClientRect.bottom < 0;


          updateStickyVisibility();

        },
        {
          threshold: 0
        }
      );


    originalButtonObserver.observe(
      originalButton
    );
  }


  /* =========================================================
     WATCH DRAWER ONLY WHILE IT IS OPEN
     ========================================================= */

  function watchFilterDrawer() {

    if (drawerWatcher) {

      clearInterval(
        drawerWatcher
      );

    }


    let drawerWasVisible = false;

    const startTime =
      Date.now();


    drawerWatcher =
      setInterval(
        function () {

          const visible =
            isFilterDrawerVisible();


          /*
           * Drawer opened.
           */
          if (visible) {

            drawerWasVisible = true;

            stickyWrapper &&
              stickyWrapper.classList.remove(
                'is-visible'
              );

            return;
          }


          /*
           * Drawer was open and has closed.
           */
          if (
            drawerWasVisible &&
            !visible
          ) {

            stickyLockedByDrawer = false;


            clearInterval(
              drawerWatcher
            );


            drawerWatcher = null;


            setTimeout(
              function () {

                updateStickyVisibility();

              },
              100
            );


            return;
          }


          /*
           * Fallback in case Enterprise opened
           * and closed too quickly.
           */
          if (
            Date.now() -
              startTime >
            800
          ) {

            const button =
              getOriginalFilterButton();


            const expanded =
              button &&
              button.getAttribute(
                'aria-expanded'
              ) === 'true';


            if (
              !expanded &&
              !visible
            ) {

              stickyLockedByDrawer = false;


              clearInterval(
                drawerWatcher
              );


              drawerWatcher = null;


              updateStickyVisibility();

            }

          }

        },
        120
      );
  }


  /* =========================================================
     CREATE BUTTON
     ========================================================= */

  function createStickyFilter() {

    if (stickyWrapper) {
      return;
    }


    const button =
      getOriginalFilterButton();


    if (!button) {
      return;
    }


    stickyWrapper =
      document.createElement(
        'div'
      );


    stickyWrapper.className =
      'g3-mobile-sticky-filter products-toolbar__filter';


    const stickyButton =
      button.cloneNode(true);


    /*
     * IMPORTANT:
     *
     * Do not allow Enterprise to attach its
     * normal filter event to the clone.
     */
    stickyButton.classList.remove(
      'js-toggle-filters'
    );


    stickyButton.setAttribute(
      'aria-label',
      'Open filters and sorting'
    );


    stickyWrapper.appendChild(
      stickyButton
    );


    document.body.appendChild(
      stickyWrapper
    );


    /* =======================================
       CLICK
       ======================================= */

    stickyButton.addEventListener(
      'click',
      function (event) {

        event.preventDefault();

        event.stopPropagation();


        stickyLockedByDrawer = true;


        stickyWrapper.classList.remove(
          'is-visible'
        );


        const latestButton =
          getOriginalFilterButton();


        if (!latestButton) {

          stickyLockedByDrawer = false;

          return;
        }


        /*
         * This triggers Enterprise's ORIGINAL
         * filter button.
         *
         * It also automatically triggers our
         * optimized filter initializer.
         */
        latestButton.click();


        watchFilterDrawer();

      }
    );
  }


  /* =========================================================
     INITIALIZE
     ========================================================= */

  function initialiseStickyFilter() {

    if (initialized) {
      return;
    }


    initialized = true;


    /*
     * No filter = nothing to do.
     */
    if (
      !getOriginalFilterButton()
    ) {
      return;
    }


    createStickyFilter();

    observeOriginalButton();

    updateStickyVisibility();
  }


  /* =========================================================
     FIRST SCROLL ONLY
     ========================================================= */

  /*
   * This is the major performance change.
   *
   * We DO NOT:
   *
   * - clone the button
   * - calculate drawer dimensions
   * - create observers
   *
   * until the visitor actually scrolls.
   */
  window.addEventListener(
    'scroll',
    initialiseStickyFilter,
    {
      once: true,
      passive: true
    }
  );


  /* =========================================================
     BACK/FORWARD RESTORED SCROLL
     ========================================================= */

  window.addEventListener(
    'pageshow',
    function () {

      if (
        window.scrollY > 50
      ) {

        initialiseStickyFilter();

      }

    }
  );


  /* =========================================================
     ORIGINAL BUTTON OPENING
     ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      if (!initialized) {
        return;
      }


      const target =
        event.target;


      if (
        !target ||
        !target.closest
      ) {
        return;
      }


      const button =
        target.closest(
          '.products-toolbar__filter-btn.js-toggle-filters'
        );


      if (!button) {
        return;
      }


      setTimeout(
        function () {

          if (
            isFilterDrawerVisible()
          ) {

            stickyLockedByDrawer = true;

            updateStickyVisibility();

            watchFilterDrawer();

          }

        },
        50
      );

    },
    true
  );


  /* =========================================================
     FILTER AJAX UPDATE
     ========================================================= */

  /*
   * Shopify/Enterprise may replace the
   * original toolbar button after AJAX filtering.
   *
   * Our main filter script sends this event.
   */
  document.addEventListener(
    'g3:filters-updated',
    function () {

      if (!initialized) {
        return;
      }


      createStickyFilter();

      observeOriginalButton();

      updateStickyVisibility();

    }
  );


  /* =========================================================
     ESC KEY
     ========================================================= */

  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key !== 'Escape' ||
        !stickyLockedByDrawer
      ) {
        return;
      }


      setTimeout(
        function () {

          if (
            !isFilterDrawerVisible()
          ) {

            stickyLockedByDrawer = false;

            updateStickyVisibility();

          }

        },
        350
      );

    }
  );


  /* =========================================================
     RESIZE
     ========================================================= */

  window.addEventListener(
    'resize',
    function () {

      if (
        window.innerWidth >=
        MOBILE_BREAKPOINT
      ) {

        if (stickyWrapper) {

          stickyWrapper.classList.remove(
            'is-visible'
          );

        }

        return;
      }


      if (initialized) {

        observeOriginalButton();

        updateStickyVisibility();

      }

    },
    {
      passive: true
    }
  );

})();